exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.oneRevDialogBox {\n    position: absolute;\n    top: 20%;\n    left: 50%;\n    margin-right: -50%;\n    transform: translate(-50%, -50%);\n    border: 2px solid red;\n    border-radius: 10px;\n    box-shadow: 2px 20px 40px 30px #666;\n    padding: 20px;\n    background-color: white;\n    max-width: 600px;\n    min-width: 500px;\n}\n.option {\n    font-size: 1.1em;\n    font-weight: bold;\n    text-decoration: underline;\n}\n.info {\n    font-weight: lighter;\n}\n", ""]);

// exports
